import { Box, Tab, Tabs } from '@mui/material'
import React from 'react'
import SearchForm from '../searchForm'
import { TabPanel, a11yProps } from '../tabPanel'
import { useTranslations } from 'next-intl'

interface FlightSearchTabsProps {
    tabValue: number
    onTabChange: (event: React.SyntheticEvent, newValue: number) => void
    isMobile: boolean
}

export const FlightSearchTabs: React.FC<FlightSearchTabsProps> = ({ tabValue, onTabChange, isMobile }) => {
    const t = useTranslations('header')
    return (
        <Box sx={{bgcolor:'common.white', px: 3,pt: 1, pb: 3, borderRadius: 2, border: 2, borderColor: 'grey.100'}}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Tabs
                    value={tabValue}
                    onChange={onTabChange}
                    aria-label="flight search tabs"
                    sx={{
                        display: { xs: 'none', md: 'flex' },
                        justifyContent: 'center',
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontSize: '0.875rem',
                            fontWeight: 500,
                            color: 'textColors.primary',
                            borderBottom: '2px solid transparent',
                            px: {xs: 0, md: 2},
                            py: 1,
                            minWidth: 'unset',
                            '&.Mui-selected': {
                                fontWeight: 600,
                                color: '#000',
                                borderBottomColor: '#000',
                                borderRadius: 1

                            }
                        },
                        '& .MuiTabs-indicator': {
                            display: 'none'
                        }
                    }}
                >
                    <Tab label={t('flights')} {...a11yProps(0)} />
                    <Tab label={t('hotels')} {...a11yProps(1)} />
                </Tabs>
            </Box>

            <TabPanel value={tabValue} index={0}>
                <SearchForm isMobile={isMobile} />
            </TabPanel>
        </Box>
    )
}
